<template>
  <div class="app-container">
    <list ref="list">
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="120">
          <template slot-scope="{row}">
            <template v-if="!row.isPrint">
              <el-button type="text" @click="openPrint(row)">打印</el-button>
              <el-button type="text" @click="onEdit(row)">编辑</el-button>
              <el-button type="text" @click="onDelete(row)">删除</el-button>
            </template>
            <template v-else>
              <div>
                <el-button type="text" @click="openPrint(row)">打印</el-button>
                <el-button type="text" @click="onEdit(row)">更新面单</el-button>
              </div>
              <div>
                <el-button type="text" @click="onRecycle(row)">回收单号</el-button>
                <el-button type="text" @click="onDelete(row)">删除</el-button>
              </div>
            </template>
          </template>
        </el-table-column>
      </template>
    </list>
  </div>
</template>
<script>
import curdMixin from "@/mixins/curd";
import list from "@/components/freeprint/index";

export default {
  mixins: [curdMixin],
  components: { list },
  data() {
    return {}
  },
  methods: {
    onEdit(row) {
      this.$refs.list.onEdit(row);
    },
    openPrint(row) {
      this.$refs.list.openPrint(row);
    },
    onDelete(row) {
      this.$refs.list.batchDelete(row)
    },
    onRecycle(row) {
      this.$refs.list.onRecycle(row);
    }
  }
}
</script>